import { connect } from 'react-redux';
import { resetSubscriptions } from '../feature/subscription-plans/store/subscriptionsSlice';
import Subscriptions from './SubscriptionRoutes';

const mapState = state => ({
  globalCustomers: state.subscriptions.globalCustomers,
});

export default connect(mapState, { resetSubscriptions })(Subscriptions);
